import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (failureCount, error) => {
        const status = typeof error === 'object' && error !== null && 'status' in error
          ? Number(error.status)
          : 0
        return status >= 400 && status < 500 ? false : failureCount < 2
      },
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
})